import React, { Fragment } from "react";

import {
  MobileSort,
  TableSearch,
} from "../../../../../../../components/table/components";
import { Mobile } from "../../../../../../../hocs/Responsive";
import { ProfileDeviceLimitReached } from "../profileDeviceLimitReached";

interface ProfileNotRoamingDevicesTableHeaderProps {
  profileId: string;
}

export const ProfileNotRoamingDevicesTableHeader = ({
  profileId,
}: ProfileNotRoamingDevicesTableHeaderProps) => {
  return (
    <Fragment>
      <TableSearch />

      <Mobile>
        <MobileSort />
      </Mobile>

      <ProfileDeviceLimitReached profileId={profileId} />
    </Fragment>
  );
};
